import { h } from "vue";
import { DefineComponent, HTMLAttributes, SetupContext } from "vue";
import { Dictionary } from "../../types";
import { Key, IconType } from "../../types/skyward/svg";

interface SvgProps
{
    name: Key,
    type?: IconType,
    showHoverEffect?: boolean,
    isButton?: boolean;
    svgClasses?: string[] | Dictionary<string, boolean>;
}

const vSvg = function vSvg(props: SvgProps, context: SetupContext)
{
    let classes: string[] = getClassName(props);
    const svgClasses = props.svgClasses;
    if (Array.isArray(svgClasses))
    {
        classes.push(...svgClasses);
    }
    else if (typeof svgClasses === "object" && svgClasses !== null)
    {
        classes.push(...Object.keys(svgClasses).filter(c => svgClasses[c]));
    }

    return (
        <svg class={classes} tabindex="-1"
        // Include all passed down classes, styles, listeners, ...
            {...context.attrs}>
            {
                // Work around an issue in Vue JSX: with optimization enabled, the xlink:href
                // attribute is never updated.  Href doesn't have this issue, but isn't supported
                // below Safari 12.
                h("use", { "xlink:href": getXLinkHRef(props) })
            }
        </svg>
    );
};
vSvg.props = ["name", "type", "showHoverEffect", "isButton", "svgClasses"];
// Note that we must not use defineComponent for functional components.
// The implementation wraps the function in an object, which causes Vue to misidentify it as a
// stateful (non-functional) component and call it with the wrong arguments.
export default vSvg as unknown as DefineComponent<SvgProps & HTMLAttributes, JSX.Element>;

function getClassName(svgProps: SvgProps)
{
    var svgName = svgProps.name[0].toLowerCase() + svgProps.name.slice(1);
    var className = ["svg", "svgGroup", svgName];

    if (svgProps.showHoverEffect === false)
    {
        className.push("svgNoHover");
    }

    if (svgProps.isButton === true)
    {
        className.push("buttonSvg");
    }

    if (svgProps.type !== undefined)
    {
        className.push("svg" + svgProps.type[0].toLocaleUpperCase() + svgProps.type.slice(1));
    }

    return className;
}

function getXLinkHRef(svgProps: SvgProps)
{
    return `${window.skyward.global.virtualDir}skysys/svg/spritesheet?v=2#svg-${svgProps.name}`;
}